import React, { useEffect } from 'react';
import { SiSubstack as _SiSubstack } from 'react-icons/si';
const SiSubstack = _SiSubstack as unknown as React.ComponentType<any>;

type Variant = 'inline' | 'button';

interface CallToActionProps {
  variant?: Variant;
  text?: string;
  buttonLabel?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({ 
  variant = 'inline', 
  text = 'Want to get notified when I post something new?',
  buttonLabel = 'Subscribe'
}) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const modal = open && (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6" style={{ backgroundColor: 'transparent' }}>
      <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
      <div className="relative rounded-md shadow-lg max-w-[95vw] w-[520px]" style={{ backgroundColor: 'var(--color-bg-primary)', border: '1px solid var(--color-border)' }}>
        <div className="p-4 border-b" style={{ borderColor: 'var(--color-border)' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <SiSubstack className="w-5 h-5" />
              <strong className='text-xl'>Subscribe</strong>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close subscribe modal" className="text-2xl px-3 py-1 leading-none">×</button>
          </div>
        </div>
        <div className="p-6">
          <iframe
            src="https://pfjacobs.substack.com/embed"
            width="480"
            height="320"
            frameBorder={0}
            scrolling="no"
            style={{ width: '100%', maxWidth: 480 }}
            title="Subscribe to my Substack"
          />
        </div>
      </div>
    </div>
  );

  if (variant === 'inline') {
    return (
      <>
        {text} <button
          onClick={() => setOpen(true)}
          className="italic font-bold text-[var(--color-main-accent)] hover:underline inline"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          {buttonLabel}
        </button>.
        {modal}
      </>
    );
  }

  // variant === 'button'
  // No drawn divider above/below, per the site-wide decision against
  // them — kept the same margin (2rem) the divider used to carry via its
  // own `margin: 2rem 0`, so removing the line doesn't also collapse the
  // spacing around this block.
  return (
    <>
      <div className="text-center pt-8 mt-8 mb-8">
        <div className="mx-auto" style={{ width: '70%' }}>
          <p className="italic text-[var(--color-text-secondary)] mb-4">
            {text}
          </p>
          <button
            onClick={() => setOpen(true)}
            className="inline-flex items-center space-x-3 px-6 py-3 rounded-md font-bold transition bg-[var(--color-main-accent)]"
            style={{ color: 'white' }}
            aria-label="Subscribe to Substack"
          >
            <SiSubstack className="w-5 h-5" />
            <span className="text-base">{buttonLabel}</span>
          </button>
        </div>
      </div>
      {modal}
    </>
  );
};

export default CallToAction;
